var _defs, _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_2",
    "data-name": "\\uADF8\\uB8F9 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    x: 21,
    y: 21,
    width: 26,
    height: 26,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABgUlEQVRIiWIgEXgyMDA8g2IQmzjAwMAAAAAA//8iFYMs+A/FIDZxgIGBAQAAAP//YiTRJpAFyIA4/QwMDAAAAAD//2KipffhgIGBAQAAAP//oo9FDAwMAAAAAP//oo9FDAwMAAAAAP//oo9FDAwMAAAAAP//oo9FDAwMAAAAAP//oo9FDAwMAAAAAP//oo9FDAwMAAAAAP//oo9FDAwMAAAAAP//AlkEK1ZgOR4fRgfE6HnGwMDgCQAAAP//Aikm1hLyMQPDMwAAAAD//6JP0DEwMAIAAAD//wIRXgwMDM9p6JsnDAwMXgAAAAD//6JPocrAwAAAAAD//6JP0DEwMAAAAAD//6KPRQwMDAAAAAD//6KPRQwMDAAAAAD//6KPRQwMDAAAAAD//6KPRQwMDAAAAAD//6KPRQwMDAAAAAD//6KPRQwMDAAAAAD//6KPRQwMDAAAAAD//yLVIlAJAgMviNbFwMAAAAAA//8iFcOKK3CxQrRmBgYGAAAAAP//AwCBuVLJkTFSVgAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.cb636b6cc11ae246c3bbcf847dbe631e.svg";
export { ForwardRef as ReactComponent };